export default {
	apiKey: "AIzaSyB5TczJo5J2eTJhOgIYjrLQBEYnfQyviL0",
	authDomain: "dh2642-flightsearch.firebaseapp.com",
	databaseURL: "https://dh2642-flightsearch-default-rtdb.europe-west1.firebasedatabase.app",
	projectId: "dh2642-flightsearch",
	storageBucket: "dh2642-flightsearch.appspot.com",
	messagingSenderId: "853788218643",
	appId: "1:853788218643:web:a01333baa1deecb989b6e6",
	measurementId: "G-DPLJCBY01Y"
}
